import { render, staticRenderFns } from "./AddOfferGroupDialog.vue?vue&type=template&id=84762bd6&"
import script from "./AddOfferGroupDialog.vue?vue&type=script&lang=js&"
export * from "./AddOfferGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports